import React, { useState } from 'react';
import { updateCommunity } from '../../ajax_utils';
import { flashForReact } from '../../flash_react';

const Access = ({ show, community }) => {
  const [discoverability, setDiscoverability] = useState(
    community.discoverability
  );
  const [errors, setErrors] = useState('');
  const params = { discoverability };

  const handleApiSuccess = (res) => {
      setErrors('');
      flashForReact('notice', res.message);
  };

  const handleApiErrors = (err) => {
      setErrors(err.errors);
      flashForReact('danger', err.message);
  };

  return (
    show && (
      <div className="community-settings" id="access">
        <div className="h2 mb-4 mt-n2">Access</div>
        <div className="form-group">
          <label className="mb-3" htmlFor="community_discoverability">
            Discoverability
          </label>
          <div className="col-md-4 d-md-flex justify-content-between mb-6">
            <div className="col-md-5 mb-2 mb-md-0">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-1-outlined"
                defaultChecked={discoverability === 'discoverability_public'}
                autoComplete="off"
              />
              <label
                className="btn btn-outline-primary w-100 admin-btn-lg"
                htmlFor="btn-check-1-outlined"
                onClick={() => setDiscoverability('discoverability_public')}
              >
                Public
              </label>
            </div>
            <div className="col-md-5">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id="btn-check-2-outlined"
                autoComplete="off"
                defaultChecked={discoverability === 'discoverability_private'}
              />
              <label
                className="btn btn-outline-primary w-100 admin-btn-lg"
                htmlFor="btn-check-2-outlined"
                onClick={() => setDiscoverability('discoverability_private')}
              >
                Private
              </label>
            </div>
          </div>
          <p className="text-gray-400 mb-6 fs-85">
            Private communities are only available to those who are invited.
          </p>
          {/* BEGIN hidden until future update */}
          <div className="form-group mb-6 d-none">
            <label className="mb-3">
              Application Questions
            </label>
            <textarea className="form-control" cols="30" rows="6" />
          </div>
        </div>
        {/* END hidden until future update */}
        <button
          className="btn btn-primary btn-lg col-md-3 col-12 update-btn"
          onClick={() =>
            updateCommunity(
              community,
              params,
              handleApiSuccess,
              handleApiErrors,
            )
          }
        >
          Update Access
        </button>
      </div>
    )
  );
};

export default Access;
